import React, {useContext, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {AuditPaneContext} from '../../context/AuditPane'
import AuditSteps from './AuditSteps'
import Title from './Title'
import Body from './Body'
import {useTranslation} from 'react-i18next'
import {ModalCloseConfirm} from '../AuditConfirmModal'
import {AuditDetailsContext} from '../../context/Modal/AuditDetails'
import {GroupDetailsContext} from '../../context/Modal/GroupDetails'
import {AuditModalBarContext} from '../../context/AuditModalBar'
import {AssignAuditContext} from '../../context/Modal/AssignAudit'
// import {AuditModalApiContext} from '../../context/AuditModalApi'
import {RecurringDetailsContext} from '../../context/Modal/RecurringDetails'
import {useModal} from '../../common/Modal'

function AuditModal() {
  const {t} = useTranslation()
  const simpleModal = useModal('simple', {})
  const paneState = useContext(AuditPaneContext)
  const {resetAuditDetails} = useContext(AuditDetailsContext)
  const {resetGroupsDetails} = useContext(GroupDetailsContext)
  const {resetBarDetails} = useContext(AuditModalBarContext)
  const {resetAssignDetails} = useContext(AssignAuditContext)
  const {resetRecurringDetails} = useContext(RecurringDetailsContext)
  const [error, setError] = useState('')
  // const {resetEntities, resetEntityDetails} = useContext(AuditModalApiContext)

  const handleClose = () => {
    // resetEntities()
    // resetEntityDetails()
    resetAuditDetails()
    resetGroupsDetails()
    resetBarDetails()
    resetAssignDetails()
    resetRecurringDetails()
    paneState.closeModal()
  }

  return (
    <>
      {paneState.isOpen && (
        <Modal
          className="audit-div"
          show={paneState.isOpen}
          onHide={() => {
            if (simpleModal) {
              simpleModal.show({
                scheme: 'warning',
                title: 'Discard changes',
                description: t('audit.alert.modal-exit-desciption'),
                buttons: {
                  affirmative: {
                    label: 'Yes',
                    click: (d, modal) => {
                      handleClose()
                      modal.hide()
                    },
                  },
                  negative: {
                    label: 'No',
                  },
                },
              })
            }
          }}
          size={paneState.modalType === 'Schedule' ? 'sm' : 'lg'}
          aria-labelledby="contained-modal-title-vcenter"
          backdrop="static"
        >
          <Title />
          {paneState.modalType !== 'Schedule' && <AuditSteps error={error} setError={setError} />}
          <Body error={error} setError={setError} />
        </Modal>
      )}
    </>
  )
}

export default AuditModal
